export default __webpack_public_path__ + "static/media/categoria.984a47c4.svg";